export default {
  ExtratoAdimplencia: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + 'extrato-adimplencia'
  })
}



//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/ExtratoAdimplencia.js
// module id = J/ks
// module chunks = 32